import React from "react";

/**
 * DS TextInput — figma 257:1538 "textplace-16" (default) / 357:9703 (error state).
 *
 * 시각 (default): white bg, border 1px Border/Default, radius 6, padding 14×10
 * 텍스트: Pretendard Regular 14/22 Text/Primary (placeholder: Text/Tertiary)
 *
 * error: 비어있지 않은 문자열이면 border System/Error + 하단 12/18 System/Error 메시지
 * multiline=true 면 textarea (figma 266:1337 — 100h)
 * readOnly=true 면 BG/Paper (figma 275:102 외부연동 readonly variant)
 *
 * @param {object} props
 * @param {string} props.value
 * @param {(v: string) => void} props.onChange
 * @param {string} [props.placeholder]
 * @param {boolean} [props.multiline]
 * @param {number} [props.rows=4]
 * @param {boolean} [props.readOnly]
 * @param {string} [props.type="text"]
 * @param {string} [props.error] - 에러 메시지 (truthy면 에러 상태)
 */
const DSTextInput = ({
  value,
  onChange,
  placeholder,
  multiline = false,
  rows = 4,
  readOnly = false,
  type = "text",
  error,
  className = "",
  style,
  ...rest
}) => {
  const hasError = !!error;
  const inputCls = [
    "ds-text-input",
    readOnly && "ds-text-input--readonly",
    hasError && "ds-text-input--error",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const inputEl = multiline ? (
    <textarea
      className={inputCls}
      rows={rows}
      value={value ?? ""}
      placeholder={placeholder}
      readOnly={readOnly}
      onChange={(e) => onChange && onChange(e.target.value)}
      style={style}
      {...rest}
    />
  ) : (
    <input
      className={inputCls}
      type={type}
      value={value ?? ""}
      placeholder={placeholder}
      readOnly={readOnly}
      onChange={(e) => onChange && onChange(e.target.value)}
      // type=number 에서 마우스 휠로 값이 바뀌는 브라우저 기본 동작 차단 (포커스 해제)
      onWheel={type === "number" ? (e) => e.currentTarget.blur() : undefined}
      style={style}
      {...rest}
    />
  );

  // 에러 유무와 무관하게 항상 동일한 루트(div)를 렌더한다.
  // 에러 토글 시 루트 타입이 input↔div 로 바뀌면 React 가 input 을 remount 하여 입력 중
  // 포커스를 잃는 문제가 생긴다. wrapper 는 display:contents 라 레이아웃에 영향 없음.
  // (figma 357:9703 — error text 12/18 System/Error)
  return (
    <div className="ds-text-input-wrap">
      {inputEl}
      {hasError && <div className="ds-text-input-wrap__error">{error}</div>}
    </div>
  );
};

export default React.memo(DSTextInput);
